function ArrowRight() {

    return(
        <svg width="12" height="12" viewBox="0 0 24 24">
            <path d="M9 6l6 6-6 6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )

}

export default ArrowRight;